<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-card>
      <v-card-title>
        База гостей
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="guests"
        :search="search"
        :loading="isLoading"
        disable-sort
        disable-filtering
        disable-pagination
        hide-default-footer
      >

        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify justify-space-around">
            <v-btn color="primary" fab x-small @click="$router.push({'name' : 'editGuest', params : {id : item.id}})"  dark title="Редактирование">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn color="blue"  @click="$router.push({'name' : 'viewGuest', params : {id : item.id}})" fab x-small  dark>
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
    <div class="text-center" v-if="lastPage > 1">
      <v-pagination
        v-model="page"
        :length="lastPage"
        circle
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
  export default {
    mounted() {
      this.loadGuests();
    },
    computed: {
      guests() {
        return this.$store.getters['guest/getGuests']
      },
      lastPage() {
        return this.$store.getters['guest/getLastPage']
      }
    },
    watch:{
      search(){
        this.page = 1;
        this.debounced(this.loadGuests)
      },
      page(){
        this.loadGuests();
      }
    },
    methods:{
      debounced: _.debounce((cb) => {
        cb()
      }, 700),
      loadGuests(){
        if(this.isLoading){
          return;
        }
        bus.$emit('onProgressLinear');
        this.isLoading = true;

        this.$store.dispatch('guest/loadGuests', {
          search : this.search,
          page : this.page
        })
          .then(() => {
            bus.$emit('offProgressLinear');
            this.isLoading = false;
          }).catch(e => console.log(e))
      }
    },
    data () {
      return {
        page:1,
        isLoading: false,
        search: '',
        headers: [
          {
            text: 'ID ',
            align: 'start',
            sortable: false,
            value: 'id',
          },
          {
            text: 'Имя ',
            align: 'start',
            sortable: false,
            value: 'first_name',
          },
          {
            text: 'Фамилия ',
            align: 'start',
            sortable: false,
            value: 'last_name',
          },
          {
            text: 'Email ',
            align: 'start',
            sortable: false,
            value: 'email',
          },
          {
            text: 'Телефон ',
            align: 'start',
            sortable: false,
            value: 'phone',
          },
          {
            text: 'Дата создания ',
            align: 'center',
            sortable: false,
            value: 'created_at',
          },
          { text: 'Actions', value: 'actions', sortable: false,   align: 'center', },
        ],
      }
    },
  }
</script>
<style scoped>
  table th + th { border-left:1px solid #dddddd; }
  table td + td { border-left:1px solid #dddddd; }
  table td  { border-top:1px solid #dddddd; }
</style>
